/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : ACCOUNT GENERAL INFO : STYLES --------------- ++++++++++ */
export default theme => ({
    general: {
        
    }
});
